import axios from 'axios';
import { httpApi } from './http';
import type { QuestionsListResponse } from '../types/question';

export class QuestionService {
  static async listActiveQuestions(): Promise<QuestionsListResponse> {
    try {
      const response = await httpApi.get<QuestionsListResponse>('/questions');

      if (!response.data) {
        throw new Error('No data received from server');
      }

      if (!response.data.success) {
        throw new Error(response.data.error || 'API request failed');
      }

      return response.data;
    } catch (error) {
      console.error('Error fetching questions:', error);
      if (axios.isAxiosError(error)) {
        throw new Error((error.response?.data as any)?.message || 'Failed to fetch questions');
      }
      throw new Error('An unexpected error occurred');
    }
  }
}
